export function LocalServer(){
    return 'https://eval.binaryspices.com//ctc/';
    // return 'http://127.0.0.1:8000/ctc/';
}